import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export function maskEmail(email) {
  if (!email || !email.includes("@")) return "•••••";
  const [local, domain] = email.split("@");
  const maskPart = (s) => (s ? s[0] + "•".repeat(Math.max(3, s.length - 1)) : "•••");
  const parts = domain.split(".");
  const tld = parts.length > 1 ? "." + parts.slice(1).join(".") : "";
  return `${maskPart(local)}@${maskPart(parts[0])}${tld}`;
}

export function MaskedEmail({ email, className = "", testid }) {
  const [revealed, setRevealed] = useState(false);
  if (!email) return <span className={className}>—</span>;
  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); setRevealed((r) => !r); }}
      title={revealed ? "Click to hide email" : "Click to reveal email"}
      className={`inline-flex items-center gap-1.5 transition-colors hover:text-[color:var(--ufr-green)] ${className}`}
      data-testid={testid}
    >
      <span className="font-mono">{revealed ? email : maskEmail(email)}</span>
      {revealed ? <EyeOff size={12} className="opacity-60" /> : <Eye size={12} className="opacity-60" />}
    </button>
  );
}
